import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyListElement;

export const DsyListElement = createComponent(
  React,
  'dsy-list-element',
  LitComp,
  {},
);

export default DsyListElement;
